<template>
  <v-container class="purple lighten-4"  style="min-height:100%;padding-bottom:350px">
   <div v-if="first_loading" class="loading">
   <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
   </div>
      <v-img
          :src="require('../assets/pattern.jpg')"
          class="my-3 pattern"
   
        />

<template v-for="(day,i) in massages">
   <v-row class="px-2" :key="i">
 
      <v-col cols="12"><v-divider></v-divider>
      <p class="my-2 p-0" style="text-align:center">{{day.date | moment("jYYYY/jMM/jDD") }}</p>
      <v-divider></v-divider>
      </v-col>  

    
        <v-col v-for="(massage,index) in day.games" :key="index" cols="12" sm="10" class="py-0 px-0 my-2" >
<v-card elevation="1" :id="index == (day.games.length-1) && i==(massages.length - 1)?'last':''" :loading="index == (massages.length-1) && i==(day.games.length - 1) && loading" :style="massage.massage_type == 1?'float:left':''" tile style="width:250px">
<p class="py-2 px-2">{{massage.massage}}</p>
<span style="color:#999" class="date px-2">

  {{massage.created_at | moment("HH:mm")}}</span>
</v-card>
 </v-col>
 </v-row>
</template>

   
       <v-footer
    fixed
      padless
      flat
      color="white"
      style="bottom:60px">
<v-textarea
class="massage-input send-massage"
            v-model="message"
            append-icon="mdi-send"
            solo
            auto-grow
          rows="2"
          row-height="20"
            clear-icon="mdi-close-circle"
            clearable
            label="پیام جدید بنویسید ..."
            type="text"
            @click:append="sendMessage"
            @click:append-outer="sendMessage"
            @click:clear="clearMessage"
          ></v-textarea>

    </v-footer>
  </v-container>
</template>
<script>
import moment from 'moment'

  export default {
    data: () => ({
      password: 'Password',
      show: false,
      message: '',
      first_loading : false,
      marker: true,
   loading : false,
    }),

    computed: {
      icon () {
        return this.icons[this.iconIndex]
      },
           massages (){
             
               
             var massages = this.$store.state.massages
              //  massages = massages.reverse()

              const groups = massages.reduce((groups, game) => {
             
  const date = game.created_at.split(' ')[0];
  if (!groups[date]) {
    groups[date] = [];
  }
  groups[date].push(game);
  return groups;
}, {});

// Edit: to add it in the array format instead
const groupArrays = Object.keys(groups).map((date) => {
  return {
    date,
    games: groups[date].reverse()
  };
});


   return groupArrays.reverse();

   
 }
    },
   

 mounted(){


this.first_loading = true


   const _this = this
console.log(this.$store.state.user_branding)  
    var senddata = {data: {data: ['select', 'agent_support','*', {agent_id:this.$store.state.user_branding.id,ORDER:{'id':'DESC'}}] }, actions: ['get'] };
     this.api_get(senddata).then(data => {
      setTimeout(function(){ 
window.scrollTo(0,document.body.scrollHeight);
_this.first_loading = false
 }, 500);
_this.$store.state.massages = data.data
     })

 },
    methods: {


      toggleMarker () {
        this.marker = !this.marker
      },
      sendMessage () {

        if(this.message.length > 0){
 var myEle = document.getElementById("last");
    if(myEle){
           this.$vuetify.goTo('#last')
    }
    var date = moment().format("YYYY-MM-DD HH:mm:ss");

        this.$store.state.massages.unshift({massage:this.message,created_at:date,assage_type:0,massage_status:0})
        this.loading = true;
            var senddata = {data: {data: ['insert', 'agent_support', {agent_id:this.$store.state.user_branding.id,massage:this.message,massage_type:0,massage_status:0,created_at:date}] }, actions: ['insert'] };
     this.api_get(senddata).then(() => {
this.loading = false;
     })
        this.resetIcon()
        this.clearMessage()

        }
       
      },
      clearMessage () {
        this.message = ''
      },
      resetIcon () {
        this.iconIndex = 0
      },
      changeIcon () {
        this.iconIndex === this.icons.length - 1
          ? this.iconIndex = 0
          : this.iconIndex++
      },
    },
  }
</script>